module.exports = __webpack_public_path__ + "media/images/illustrations/character-development-02-123f6f3f7032272eaca6b9a8aff34e3a.svg";